import GeofenceControlsTitle from './GeofenceControlsTitle';

export default GeofenceControlsTitle;
